import React, { useContext,useState,useEffect, useRef, useCallback, useMemo } from "react";
import studylistContext from "../../../../context/studylist/StudylistContext";
import { tabDetails } from "../../helpers/initData";
import { onTabSelect } from "../../helpers/helpingFunctions";
import themeContext from "../../../../context/theme/ThemeContext";
import { TabList, Tab } from "@fluentui/react-tabs";
import StudyListTab from "../StudyListTab/StudylistTab";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import ConfirmModal from "../../../../components/Modal/ConfirmModal";
import { use } from "i18next";
import SubmitTick from "../../../StudyViewer/Components/SubmitTick/SubmitTick";
import RSNAModal from "../../../Report/components/ReportModals/RSNAModal/RSNAModal";
import ViewReportModal from "../..//components/Modal/ReportVersion/ViewReportModal";
import {CXR_TABS, USERTYPES, CXR_SUBTABS_ID, CXR_TABS_ALLOWED_ROLES, BASIC_STUDYLIST, TABS, CUSTOM_STYLES, PEER_REVIEW_SUBTABS_ID, QC_REVIEW_SUBTABS_ID, QC_REVIEW_TABS, ARCHIVED_ACCESS_SUBTABS_ID, SAVED_SUBTABS_ID, REPORTED_SUBTABS_ID, STUDY_SEARCH_RESULTS_ID, UNREPORTED_SUBTABS_ID} from "../../../../constants/Constants";
import { hasGlobalSearchCriteria } from "../../helpers/globalSearchHelpers";
import AlertSuccessModal from "../../../../components/AlertSuccessModal/AlertSuccessModal";
import UploadStudy from "../UploadStudy/UploadStudy";
import ExportCsv from "../ExportCsv/ExportCsv";
import CommunicationModal from "../../../Communication/CommunicationModal";
import ReturnStudy from "../ReturnStudy";
import { RefreshIcon } from "@fluentui/react-icons-mdl2";
import ExternalReporting from "../Modal/ExternalReporting/ExternalReporting";
import { t } from "i18next";
import "../../StudyList.css";
import BasicViewerSwitch from "../../../../components/SVGComponents/BasicViewerSwitch";
import { ContextualMenu, Icon, IconButton, PrimaryButton, TooltipHost } from "@fluentui/react";
import ConfirmAlertModal from "../../../../components/ConfirmAlertModal/ConfirmAlertModal";
import CustomDefaultButton from "../CustomButton/CustomDefaultButton";
import ProgressBarState from "../../../../context/progressbar/ProgressBarState";
import AddStudy from "../AddStudy/AddStudy";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import userContext from "../../../../context/users/UserContext";
import DownloadBatchRequestsModalTrigger from "../../../../components/navbar/DownloadBatchRequestsModalTrigger";
import RightArrow from "../../../../components/SVGComponents/RightArrow";
import LeftArrow from "../../../../components/SVGComponents/LeftArrow";
import { getEnv } from '../../../../helpers/EnvHelper';

const StudyListNavTabs = () => {

    const {
        setAllStudies,
        studyData,
        columns,
        allStudies,
        searchDto,
        setSearchDto,
        sortGlobal,
        setSortGlobal,
        filterInputValues,
        showFilters,
        setShowFilters,
        applyClick,
        setApplyClick,
        storefilterBadges,
        setStoreFilterBadges,
        filterBadges,
        setFilterBadges,
        roles,
        hideModal,
        showCommunicationModal,
        setShowReturnedStudyReasonModal,
        showReturnedStudyReasonModal,
        showCount,
        setShowCount,
        patientNameBadgeShow,
        removeBadgeFromFilter,
        setPatientDetail,
        setPatientNameBadgeShow,
        setModalityIds,
        refreshRequired,
        setRefreshRequired,
        storedRows,
        setStoredRows,
        setShowClientName,
        setDataQueryState,
        setSearchResultLength,
        dataQueryState,
        showVersionModalForReport,
        showAddStudy,
        handleEnterKeyPress,
        showGenericConfirmModal, setShowGenericConfirmModal,
        handleGenericConfirmModal,
        confirmMessage, setConfirmMessage,
        showDeleteModal, setShowDeleteModal,
        showImageDeleteModal,setShowImageDeleteModal,
        deleteStudyFunc,
        handleCloseDeleteModal,
        showDeleteSuccessModal, setShowDeleteSuccessModal,
        deleteSuccessMessage, setDeleteSuccessMessage,
        showReInferenceModal, setShowReInferenceModal,
        handleCloseReInferenceModal,
        showConfirmModalState,setShowConfirmModalState,
        handleBatchReInference,
        selectedValue, setSelectedValue,
        unreportedAllTabs,setUnreportedAllTabs,
        peerReviewAssignedTab,
        savedAllTabs,
        archivedStudyRequestTab,
        reportedAllTabs,
        qcReviewAllTabs,
        handleQCReviewTabChange,
        handleCXRTabChange,
        searchResultLengthObj,setSearchResutLengthObj,
        filterApplied,setFilterApplied,
        setResetRowSelection,
        alertSuccessStudyListState, setAlertSuccessModalStudyListState,
        handleRefresh,
        studyListLoading,setStudyListLoading,
        setShowExportCsvModal,
        setShowDownloadsModal,
        showDownloadsModal,
        showExportCsvModal,
        showAddStudyModal,
        setShowAddStudyModal,
        setShowExportCsvConfirmModal,
        minimalClientFirmList,
        tabBadgeState,
        handleBlitzReporting,
        isGlobalSearch,
        hasGlobalSearchSession,
        closeGlobalSearchSession,
        promptEmptyGlobalSearch,
      } = useContext(studylistContext);

      const {contextSwitchUser,qcReviewer, qcOutsourceLogin, peerReviewAdmin, peerReviewEvaluator, blitzSessionEnabled, exportCsvAllowed,enableStudyUpload } = useContext(userContext);

      const {
        setStudyParentId,
        openReportModal,
        setOpenReportModal,
        modalityReport,
        showSubmitTick,
        openRSNAModal,
        regenerateClick,
        RSNAModalContent,
        setOpenRSNAModal,
        alertSuccessModal, setAlertSuccessModal,
        hideAlertSuccessModal,
        studyPatientDetails,
        lockStudy,
        confirmAlertModal,
        checkIfCancelOrNot,
        assignmentData
      } = useContext(studyReportContext);

    const { isActiveData } = useContext(userContext);

    const { themeName, getThemeColor } = useContext(themeContext);
    const linkRef = useRef(null);
    const [delayHandler, setDelayHandler] = useState(null);

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [isUploadStudyAllowed, setIsUploadStudyAllowed] = useState(true);
    
    
    const [showUploadStudyModal, setShowUploadStudyModal] = useState(false);
    const [confirmResponseMessage, setConfirmResponseMessage] = useState("");
    const [showContextualMenu, setShowContextualMenu] = useState(false);

      const getTabActiveStatus = (tabId) =>{
        if(selectedValue === tabId) return true;
        else if(UNREPORTED_SUBTABS_ID.includes(tabId) && UNREPORTED_SUBTABS_ID.includes(selectedValue)) return true;
        else if(PEER_REVIEW_SUBTABS_ID.includes(tabId) && PEER_REVIEW_SUBTABS_ID.includes(selectedValue)) return true;
        else if(ARCHIVED_ACCESS_SUBTABS_ID.includes(tabId) && ARCHIVED_ACCESS_SUBTABS_ID.includes(selectedValue)) return true;
        else if(SAVED_SUBTABS_ID.includes(tabId) && SAVED_SUBTABS_ID.includes(selectedValue)) return true;
        else if(QC_REVIEW_SUBTABS_ID.includes(tabId) && QC_REVIEW_SUBTABS_ID.includes(selectedValue)) return true;
        else if(REPORTED_SUBTABS_ID.includes(tabId) && REPORTED_SUBTABS_ID.includes(selectedValue)) return true;
        return false;
      }

      // const handleCloseExportCsvConfirmModal = () => {
      //   setShowExportCsvConfirmModal(false);
      //   setShowConfirmModal(false);
      // };

      const handleExportCsv = () => {
        setShowExportCsvModal(true);
      };

      const handleDownloads = () =>{
        setShowDownloadsModal(true);
      }
    
      const handleUploadStudy = () => {
        setShowUploadStudyModal(true);
      };

      const regenerateRSNA = (reportName) => {
        setOpenRSNAModal(false);
        if (reportName == "TUBERCULOSIS") {
          regenerateClick();
        }
      };

      const hideViewerModal = () => {
        setOpenRSNAModal(false);
      }

      useEffect(()=>{
        if(openRSNAModal){
          const layerElement = document.getElementById("fluent-default-layer-host");
          if(layerElement){
            layerElement.style.display = 'none';
          }
        }else{
          const layerElement = document.getElementById("fluent-default-layer-host");
          if(layerElement){
            layerElement.style.display = 'block';
          }
        }
      },[openRSNAModal])

      const contextMenuStyle = useMemo(() => ({
        root: {
         backgroundColor: getThemeColor('action-details-background'),
         borderRadius: "5px",
        border: "1px solid #585858",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
        },
        item: {
          selectors: {
          ":hover": {
            backgroundColor:'green'
          },
          },
        },
      }), [getThemeColor]);

      const onHideContextualMenu = useCallback(() => setShowContextualMenu(false), []);

      const hideContextMenu = () => {
        clearTimeout(delayHandler);
        setDelayHandler(
          setTimeout(() => {
            setShowContextualMenu(false);
          }, 300)
        );
      };
    
      const showContextMenu = () => {
        clearTimeout(delayHandler);
        setDelayHandler(
          setTimeout(() => {
            setShowContextualMenu(true);
          }, 300)
        );
      };

        useEffect(() => {
          if (
            roles[0] === USERTYPES.ADMIN || 
            roles[0] === USERTYPES.FIRMADMIN
          ) {
            setIsUploadStudyAllowed(true);
          } 
          else if (roles[0] === USERTYPES.RADIOLOGIST &&  (minimalClientFirmList?.length ?? 0) !== 0) {
            setIsUploadStudyAllowed(true);
          }
          else if (
            roles[0] === USERTYPES.FIRMDOCTOR ||
            roles[0] === USERTYPES.FIRMTECHNICIAN ||
            roles[0] === USERTYPES.SUPERVISOR
          ) {
            setIsUploadStudyAllowed(enableStudyUpload || false);
          }
          else {
            setIsUploadStudyAllowed(false);
          }
        }, [roles, enableStudyUpload, minimalClientFirmList]);


      useEffect(() => {
        clearTimeout(hideContextMenu);
      }, [showContextualMenu]);

      const menuPropsItems = useMemo(() => {
        let items = [];
        if(exportCsvAllowed){
          items.push({
            key: 'export-csv',
            text: t("button.export-csv"),
            onClick:() => handleExportCsv(),
            disabled: !isActiveData
          });
        }
        if(!qcOutsourceLogin){
          items.push({
            key: 'upload-study',
            text: t("button.upload-study"),
            onClick:() => handleUploadStudy(),
            disabled: !isUploadStudyAllowed|| !isActiveData
          });
        }
          items.push({
            key: 'refresh',
            text: t("button.refresh"),
            onClick:() => handleRefresh()
          });
          return items;
      }, [exportCsvAllowed, qcOutsourceLogin, isActiveData, isUploadStudyAllowed]);

      function getNumber(str){
        const txt = str.split('_').pop();
        return txt;
      }

      useEffect(()=>{
        let currentTab = selectedValue;
        if(document.getElementById(currentTab) != null){
          if(themeName != "light"){
            document.getElementById(currentTab).style.border = CUSTOM_STYLES.ACTIVE_TAB;
            document.getElementById(currentTab).style.background = "unset";
          }else if(themeName === "light") {
            document.getElementById(currentTab).style.background =
            TABS.ACTIVE_BACKGROUND;
          }
          document.getElementById(currentTab).style.borderRadius =
            "10px 10px 0px 0px";
          document.getElementById(currentTab).style.borderBottom =
            "1px solid rgba(0,0,255,0.1)";
          
          for (let i = 1; i <= tabDetails.length; i++) {
            if (tabDetails[i-1]?.show == true && currentTab.charAt(currentTab.length - 1) != i && getNumber(currentTab) != i) {
              document.getElementById(`study_${i}`).style.border = "";
              document.getElementById(`study_${i}`).style.borderRadius = "";
              document.getElementById(`study_${i}`).style.borderBottom = "";
              document.getElementById(`study_${i}`).style.background = "";
            }
          }
        }

       
      },[themeName])
    // ------------------------start----------------------------
    const tabScrollRef = useRef(null);
    const [canLeft, setCanLeft]   = useState(false);
    const [canRight, setCanRight] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const EPS = 2;

    const updateArrows = useCallback(() => {
      const el = tabScrollRef.current;
      if (!el) return;

      const { scrollLeft, scrollWidth, clientWidth } = el;
      const overflow = scrollWidth > clientWidth + EPS;

      setIsOverflowing(overflow);
      setCanLeft(overflow && scrollLeft > EPS);
      setCanRight(overflow && scrollLeft + clientWidth < scrollWidth - EPS);
    }, []);

    useEffect(() => {
      const el = tabScrollRef.current;
      if (!el) return;
      updateArrows();
      el.addEventListener("scroll", updateArrows);
      // Debounce the ResizeObserver callback to prevent an oscillation loop
      // where showing/hiding NavArrows changes the container width, which
      // fires the observer again before the layout has settled.
      let roTimer;
      const debouncedUpdate = () => {
        clearTimeout(roTimer);
        roTimer = setTimeout(updateArrows, 50);
      };
      const ro = new ResizeObserver(debouncedUpdate);
      ro.observe(el);
      window.addEventListener("resize", updateArrows);
      return () => {
        el.removeEventListener("scroll", updateArrows);
        ro.disconnect();
        clearTimeout(roTimer);
        window.removeEventListener("resize", updateArrows);
      };
    }, [updateArrows]);

    const scrollByStep = (dir) => {
      const el = tabScrollRef.current;
      if (!el) return;
      const step = Math.max(240, el.clientWidth * 0.6); // how far one click moves
      el.scrollBy({ left: dir * step, behavior: "smooth" });
    };

    // keep the selected tab in view when it changes
    useEffect(() => {
      const scroller = tabScrollRef.current;
      if (!scroller) return;
      if (selectedValue === STUDY_SEARCH_RESULTS_ID) {
        scroller.scrollTo({ left: 0, behavior: "smooth" });
        return;
      }
      const active = scroller.querySelector('[aria-selected="true"]');
      active?.scrollIntoView({ inline: "center", block: "nearest", behavior: "smooth" });
    }, [selectedValue]);

    const NavArrow = ({ dir, active, onClick }) => {
      const onKeyDown = (e) => {
        if (!active) return;
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      };
      return (
        <div
          className={`tabs-nav ${dir} ${active ? "active" : "disabled"}`}
          role="button"
          aria-label={`Scroll tabs ${dir}`}
          aria-disabled={!active}
          tabIndex={active ? 0 : -1}
          onClick={active ? onClick : undefined}
          onKeyDown={onKeyDown}
        >
          {dir === "left" ? <LeftArrow active={active} /> : <RightArrow active={active} />}
        </div>
      );
    };
    // ------------------------end----------------------------

    return (
      <div style={{  background: "var(--studylist-search-and-tab-section-background)" }}>
        <div className="study-list-top-tab" 
        style={{paddingTop :  getEnv("REACT_APP_VDC_PLATFORM") === "true" ? "4px" : "0px",
           background: themeName === "light" ? "#EEEEEE":"var(--studylist-search-and-tab-section-background)"
        }}>
        <div data-tut={"tour-tab-section"} className="study-list-tabs">
          {isOverflowing && canLeft && (
              <NavArrow dir="left"  active={canLeft}  onClick={() => scrollByStep(-1)} />
           )}
  <div className="study-list-tab-scroll no-scrollbar" ref={tabScrollRef}>
          <TabList
            className="study-list-tab-container"
            selectedValue={selectedValue}
            onTabSelect={(event, data) => {
              if (
                roles[0] === USERTYPES.SUPERVISOR &&
                data.value === "study_24" &&
                !QC_REVIEW_SUBTABS_ID.includes(selectedValue)
              ) {
                handleQCReviewTabChange(
                  "qcreviewAssigned",
                  QC_REVIEW_TABS.qcreviewAssigned,
                  "study_24"
                );
              }
              onTabSelect(
                event,
                data,
                tabDetails(roles, selectedValue,themeName, unreportedAllTabs || { data: {} }, peerReviewAssignedTab, contextSwitchUser, qcReviewer, qcOutsourceLogin, peerReviewAdmin, peerReviewEvaluator, archivedStudyRequestTab, savedAllTabs, reportedAllTabs || { data: {} }, qcReviewAllTabs || { data: {} }, isGlobalSearch, hasGlobalSearchSession),
                setSelectedValue,
                themeName,
                setSortGlobal,
                sortGlobal
              );
              if (data.value === STUDY_SEARCH_RESULTS_ID && !hasGlobalSearchCriteria(searchDto)) {
                promptEmptyGlobalSearch?.();
              }
              setSearchResultLength(dataQueryState?.data?.rows?.length);
            }}
          >
             {tabDetails(roles, selectedValue,themeName, unreportedAllTabs || { data: {} }, peerReviewAssignedTab, contextSwitchUser,qcReviewer, qcOutsourceLogin, peerReviewAdmin, peerReviewEvaluator, archivedStudyRequestTab, savedAllTabs, reportedAllTabs || { data: {} }, qcReviewAllTabs || { data: {} }, isGlobalSearch, hasGlobalSearchSession).map((tabElement, index) => {
              const tabBadgeData = tabBadgeState[tabElement.tabNameId];
              const tabCount = tabBadgeData && tabBadgeData.showBadge? tabBadgeData.value: 0;  
              return (
                tabElement.show && (
                  <Tab
                    key={index}
                    className={!getTabActiveStatus(tabElement.id)?`tab-container-cmp-study-list`:`tab-container-inactive-cmp`}
                    id={tabElement.id}
                    value={tabElement.id}
                  >
                    <StudyListTab
                      title={tabElement.title}
                      icon={tabElement.icon}
                      contentClass={tabElement.contentClass}
                      active={getTabActiveStatus(tabElement.id)} 
                      count={tabCount}
                      showCloseButton={tabElement.id === STUDY_SEARCH_RESULTS_ID}
                      onClose={closeGlobalSearchSession}
                      />
                  </Tab>
                )
              );
            })}
          </TabList>
        </div>
          {isOverflowing && canRight && (
            <NavArrow dir="right" active={canRight} onClick={() => scrollByStep(1)} />
          )}
        </div>
        {alertSuccessModal?.show && (
              <AlertSuccessModal
                isError={alertSuccessModal.isError}
                isWarning={alertSuccessModal.isWarning}
                isSuccess={alertSuccessModal.isSuccess}
                heading={alertSuccessModal.heading}
                description={alertSuccessModal.description}
                hideModal={hideAlertSuccessModal}
                isModalOpen={alertSuccessModal?.show}
              />
            )}

        {confirmAlertModal?.show && (
                  <ConfirmAlertModal
                    isError={confirmAlertModal.isError}
                    heading={confirmAlertModal.heading}
                    isConflictPopup={confirmAlertModal.isConflictPopup}
                    description={confirmAlertModal.description}
                    hideModal={hideAlertSuccessModal}
                    isModalOpen={confirmAlertModal?.show}
                    type={confirmAlertModal.type}
                    lockStudy={lockStudy}
                    assignmentData={null}
                    checkIfCancelOrNot={checkIfCancelOrNot}
                    annotationData={null}
                    activeViewportIndex={null}
                    annotationDataAI={null}
                    keyImages={0}
                    setConfirmAlertModal={null}
                    allTextToolAnnotation={[]}
                  />
                )}

        {openReportModal && <ExternalReporting />}

          {/* {showGenericConfirmModal && showConfirmModalState && (
            <ConfirmModal
              handleConfirm={handleGenericConfirmModal}
              handleNotConfirm={handleGenericConfirmModal}
              setShowConfirmModal={setShowConfirmModalState}
              showConfirmModal={showConfirmModalState}
              message={confirmMessage}
              title={t("confirm-message.alert")}
              confirmButtonText={t("confirm-message.ok")}
            />
          )} */}
          {(showDeleteModal ||showImageDeleteModal)  && showConfirmModalState && (
            <ConfirmModal
              handleConfirm={deleteStudyFunc}
              handleNotConfirm={handleCloseDeleteModal}
              setShowConfirmModal={setShowConfirmModalState}
              showConfirmModal={showConfirmModalState}
              message={confirmMessage}
              title={showImageDeleteModal?t("confirm-message.confirm-delete-image"):t("confirm-message.confirm-delete-study")}
              confirmButtonText={t("confirm-message.yes")}
            />
          )}
          
          {showDeleteSuccessModal && showConfirmModalState && (
            <ConfirmModal
              handleConfirm={handleCloseDeleteModal}
              handleNotConfirm={handleCloseDeleteModal}
              setShowConfirmModal={setShowConfirmModalState}
              showConfirmModal={showConfirmModalState}
              message={deleteSuccessMessage}
              title={t("confirm-message.alert")}
              confirmButtonText={t("confirm-message.ok")}
            />
          )}
          {showReInferenceModal && showConfirmModalState && (
            <ConfirmModal
              handleConfirm={handleCloseReInferenceModal}
              handleNotConfirm={handleCloseReInferenceModal}
              setShowConfirmModal={setShowConfirmModalState}
              showConfirmModal={showConfirmModalState}
              message={t("confirm-message.reInference-message")}
              title={t("confirm-message.alert")}
              confirmButtonText={t("confirm-message.ok")}
            />
          )}

        {showExportCsvModal && (
          <ExportCsv
            setShowExportCsvModal={setShowExportCsvModal}
            showExportCsvModal={showExportCsvModal}
            setShowExportCsvConfirmModal={setShowExportCsvConfirmModal}
            // setShowConfirmModal={setShowConfirmModal}
            // setConfirmResponseMessage={setConfirmResponseMessage}
          />
        )}

        {showDownloadsModal && (
          <DownloadBatchRequestsModalTrigger 
            showDownloadsModal = {showDownloadsModal}
            setShowDownloadsModal = {setShowDownloadsModal} 
          />
        )}

{showAddStudyModal && (
          <AddStudy
            setShowAddStudyModal={setShowAddStudyModal}
            showAddStudyModal={showAddStudyModal}
            />
        )}

        {/* {showExportCsvConfirmModal && showConfirmModal && (
          <ConfirmModal
            handleConfirm={handleCloseExportCsvConfirmModal}
            setShowConfirmModal={setShowConfirmModal}
            showConfirmModal={showConfirmModal}
            message={confirmResponseMessage}
            title={t("confirm-message.request-for-export-csv")}
            confirmButtonText={t("confirm-message.ok")}
          />
        )} */}

        
        {showUploadStudyModal && (
          <ProgressBarState>
            <UploadStudy
              setShowUploadStudyModal={setShowUploadStudyModal}
              showUploadStudyModal={showUploadStudyModal}
            />
          </ProgressBarState>
        )}
        {showCommunicationModal.show && (
          <CommunicationModal
            isModalOpen={showCommunicationModal.show}
            child={showCommunicationModal.child}
            hideModal={hideModal}
            studyParentId={showCommunicationModal.studyId}
            setDataQueryState = {setDataQueryState}
            dataQueryState = {dataQueryState}
            studylist={true}
          />
        )}
        {showReturnedStudyReasonModal.show && (
          <ReturnStudy studyId={showReturnedStudyReasonModal.studyId} />
        )}
        {showSubmitTick &&  <SubmitTick />}
        {showVersionModalForReport?.show &&
          <ViewReportModal />
        }
        {openRSNAModal && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                  zIndex: 10000000,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <RSNAModal
                  regenerateClick={regenerateRSNA}
                  hideModal={hideViewerModal}
                  content={RSNAModalContent}
                  isModalOpen={openRSNAModal}
                />
              </div>
            )}
           
        <div className={`top-btns-studylist ${roles[0] === USERTYPES.FIRMADMIN ? "study-list-buttons" : ""}`}>
          {(roles[0] !== USERTYPES.TYPIST)
            && <CustomToolTipHost content={t("button.downloads")}>
                  <PrimaryButton
                    iconProps={{
                      iconName: "Installation",
                      cursor: "pointer",
                    }}
                    onClick={handleDownloads}
                    style={{ marginRight: '10px', minWidth: "20px" }}
                    disabled={!isActiveData} />
            </CustomToolTipHost>
          }

          {(roles[0] == USERTYPES.ADMIN || ((roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.SUPERVISOR || roles[0] == USERTYPES.FIRMDOCTOR || roles[0] == USERTYPES.FIRMTECHNICIAN) && exportCsvAllowed)) 
          && <PrimaryButton
          onClick={handleExportCsv} 
          text={t("button.export-csv")} 
          style={{marginRight:'10px'}} 
          disabled={!isActiveData}/>}
          
          {(roles[0] == USERTYPES.TYPIST && showAddStudy )  && 
          <PrimaryButton
            onClick={()=>{setShowAddStudyModal(true);}} 
            text={t("button.add-study")}
            style={{marginRight:'10px'}} 
            disabled={!isActiveData}/>
          }

          {(roles[0] == USERTYPES.SUPERVISOR && blitzSessionEnabled && qcOutsourceLogin) 
          ? <PrimaryButton
              onClick={handleBlitzReporting} 
              text={"Blitz Session"} 
              style={{marginRight:'10px'}} 
              disabled={!isActiveData}/> : <></>}

          {/* {(roles[0] != USERTYPES.ADMIN) && */}
          {isUploadStudyAllowed ? (
            !contextSwitchUser && !qcOutsourceLogin &&
            <PrimaryButton
            onClick={handleUploadStudy} 
            text={t("button.upload-study")}
            style={{marginRight:'10px'}} 
            disabled={!isActiveData}
          />
          ) : (
            roles[0] != USERTYPES.TYPIST && !qcOutsourceLogin &&
            <CustomToolTipHost content={t("upload-study.upload-not-allowed")}>
              <PrimaryButton
                onClick={handleUploadStudy} 
                text={t("button.upload-study")}
                style={{marginRight:'10px'}} 
                disabled = {!isUploadStudyAllowed || !isActiveData}
              />
           </CustomToolTipHost>
          )}
          {/* } */}
          <PrimaryButton
          iconProps={{
            iconName: "Refresh",
            cursor: "pointer",
          }}
           onClick={handleRefresh} 
           text={t("button.refresh")} 
           disabled={studyListLoading}/>   
        </div>

        {roles[0] === USERTYPES.FIRMADMIN && <div ref={linkRef} className="study-list-actions-icon study-list-context-menu" style={{cursor: 'pointer',display:'flex',justifyContent:'center',alignItems:'center',padding:'5px'}} onClick={(e)=>{
          e.stopPropagation();
          e.preventDefault();
          setShowContextualMenu((prev)=>!prev)}
        }  
          onMouseEnter={(e)=>{
            e.stopPropagation();
            showContextMenu();
          }
        }
          onMouseLeave={(e) =>{
            e.stopPropagation();
            hideContextMenu();
          }
        }>
              
                <Icon
                iconName="GlobalNavButton"
                onClick={(e)=>{e.stopPropagation();e.preventDefault();setShowContextualMenu((prev)=>!prev)}}
              ></Icon>
              <div onMouseLeave={(e)=>{e.stopPropagation(); clearTimeout(delayHandler);setShowContextualMenu(false)}}>
              {showContextualMenu && <ContextualMenu
                styles={contextMenuStyle}
                items={menuPropsItems}
                target={linkRef}
                onItemClick={onHideContextualMenu}
                onDismiss={onHideContextualMenu}
              />}
                </div>
              
             
            </div>}

      </div>
      </div>
    )
}

export default StudyListNavTabs;